import { getCharTypedMarkerText, getSVGMarkerNumberText } from '@/utils/text-kit';
import type { TextRenderInput } from '../types';

/**
 * 生成当前列表每个段落实际使用的 marker 文案。
 *
 * @param input - 当前完整 Text Render Input。
 * @returns 按段落顺序生成的 marker 文案；无 marker 或未启用自动编号时返回空数组。
 */
export const createListMarkerTexts = (input: TextRenderInput): string[] => {
    const marker = input.listMarker;
    if (!marker) return [];

    const paragraphCount = Math.max(input.text.split('\n').length, 1);
    if (marker.kind === 'character') {
        return Array.from({ length: paragraphCount }, (_, index) => getCharTypedMarkerText(marker.style, index + 1));
    }

    if (marker.kind !== 'svg' || !marker.autoIncrement || marker.autoIncrement === 'none') return [];

    const { autoIncrement, padZero } = marker;
    return Array.from({ length: paragraphCount }, (_, index) =>
        getSVGMarkerNumberText(autoIncrement, index + 1, { padZero }),
    );
};
